export * from './lib/auth-layout.component';
